import { TableFieldValueType } from "./form-field.interface";

export interface WeatherData {
  data: TableFieldValueType[];
  fields: WeatherField[];
}

export interface WeatherDataSingle {
  data: TableFieldValueType;
  fields: WeatherField[];
}

export interface WeatherField {
  fieldId: number;
  fieldName: string;
}
